import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.min.css'
import store from './store';
import 'highlight.js/styles/vs2015.css'
import './assets/styles/fonts.css'
const app = createApp(App)
app.use(router)
app.use(store)
app.mount('#app')
store.dispatch('initDarkMode')
